import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import 'react-datepicker/dist/react-datepicker.min.css';
import './styles';

const iconSize = {
    width: 34,
    height: 34
};

const iconColor = "#999";

const onClick = (newDate, onChangeDate, event) => {
    event.preventDefault();
    onChangeDate(newDate);
};

const SingleDatePicker = ({
    headerText = '',
    currentDate,
    minDate,
    maxDate,
    showButtons = true,
    onChangeDate,
    filterDate = () => true,
    showTodayButton = true,
    mobileMode = false
}) => {
    return (
        <div className="date-picker-container">
            <h4>{headerText}</h4>
            {showButtons &&
                <div className="date-picker-controls prev">
                    <a onClick={onClick.bind(this, moment(currentDate).subtract(1, 'days'),
                            onChangeDate)}>
                        <FontAwesomeIcon icon={['fas', 'chevron-left']}/>
                    </a>
                </div>
            }
            <DatePicker
                todayButton={showTodayButton && 'Today'}
                selected={currentDate}
                onChange={onChangeDate}
                filterDate={filterDate}
                minDate={minDate}
                maxDate={maxDate}
                showYearDropdown
                dropdownMode="select"
                withPortal={mobileMode}
            />
            {showButtons &&
                <div className="date-picker-controls next">
                    <a onClick={onClick.bind(this, moment(currentDate).add(1, 'days'),
                        onChangeDate)}>
                        <FontAwesomeIcon icon={['fas', 'chevron-right']}/>
                    </a>
                </div>
            }
        </div>
    );
};

export default SingleDatePicker;
